export default {
  header: {
    language: 'CN',
    languageMb: '中文',
    logout: "登出",
    rule: "規則",
    viewRule: "查看規則",
    shrinkMenuName:'類別',
    size:'尺寸'
  },
  countdown: {
    begintime:"{name}開啟時間",
    countDownText:"距離{name}開啟",
    countDown:"倒計時"
  },
  end: {
    end:"活動已結束",
    order:"查看我的訂單"
  },
  common: {
    "0":{
      symbol: '{value}pt',
    },
    "1":{
      symbol: 'HK${value}',
    },
    "2":{
      symbol: 'HK${value}',
    },
    buyconfirm: "",
    confirmOrder: "確認訂單",
    confirm: "確定",
    cancel: "取消",
    back: "返回",
    agreement:'用戶協議',
    rule: '使用介紹',
    ruleTitle: '使用介紹',
    warning:"提示",
    pt:"積分",
    remainAmount:"額度",
    agree:"同意"
  },
  index: {
    empty: "當前沒有可參加的活動",
  },
  login: {
    userName: '用戶名',
    nameTip: '請輸入用戶名',
    password: '密碼',
    passwordTip: '請輸入密碼',
    login: '登錄',
    changePassword: '修改密碼',
    oldPassword: '原密碼',
    newPassword: '新密碼',
    affirmPassword: '確認密碼',
    submit: '提交',
    cancel: '取消',
  },
  footer: {
    activity: '活動',
    classify: '分類',
    cart: "購物車",
    my: '我的'
  },
  goods: {
    specification: '選擇規格',
    selectModel: '選擇型號',
    quantity: '購買數量',
    productDetails: '商品詳情',
    addCart: '加入購物車',
    buy: '立即購買',
    stock: '庫存',
    exchange: "立即兌換",
    minQuota: "限購",
    sellOut: "售罄",
    productPrice: "價格",
    notFound: "抱歉，沒有找到相關的商品~",
  },
  screen: {
    classify: '分類',
    sort: '排序',
    all: '全部',
    sortOne: '價格從高到低',
    sortTwo: '價格從低到高'
  },
  order: {
    cancelTip:"您確定取消該訂單嗎?",
    empty:"還沒有訂單喲，親~",
    empty2:"還沒有此類訂單喲，親~",
    myOrder: '我的訂單',
    allOrder: '全部訂單',
    noPayment: '未付款',
    havePaid: '已付款',
    shipped: '已發貨',
    isAll: '共',
    variable: '件 商品',
    subtotal:"小計",
    total: '合計',
    cancelOrder: '取消訂單',
    cancelOrder1: '取消訂單',
    cancelSuccess:"取消訂單成功",
    cancelFailed:"取消失敗，請重試",
    cancelBuy: '取消訂單',
    pay: '支付',
    orderStatus: '訂單狀態',
    consignee: '收  貨  人',
    orderTime: '下單時間',
    payTime: '付款時間',
    orderNumber: '訂單編號',
    canceled: '已取消',
    allOrders: "全部訂單",
    orderDetail: "訂單詳情",
    telephone: "手機號碼",
    transactionNo: "交易編號",
    paymentMethod: "付款方式",
    address: "收貨地址",
    realPayment: "實付",
    exportOrder: "導出訂單",
    downloadInvoice: "下載訂單",
    wechatPay:"微信支付",
    pointPay:"積分兌換",
    pointPay1:"積分兌換",
    outOfStock:"部分商品庫存不足，未下單成功",
    confirmOrderExpire: "請在{expire}前完成支付。",
    downloadVoiceConfirm: "下载订单!",
    affirm: "确认",
    cancel: "取消"
  },
  cart: {
    selected1:"已選擇",
    yourPoint:"您擁有積分",
    yourAmount:"您的剩余額度",
    empty:"購物車空空的哦~，去看看心儀的商品吧~",
    confirmDelete: "您確定要在購物車中刪除該商品?",
    buy: "結算",
    tip: '提示',
    confirm:"Confirm",
    deleteTip: '您確定要在購物車中刪除該商品',
    cancel: '取消',
    affirm: '確定',
    isAll: '全選',
    settlement: '提交',
    selectNote: "請選擇商品!",
    confirmOrder: "一旦您確認下單，訂單就不可取消和修改，您依然確定要下單嗎？",//壹個人只有{orderQty}次下單機會，壹經付款，訂單就不可取消和修改，您依然確定要下單嗎？",
    continue: "繼續購物",
    goHome: "去購物",
    delete: "刪除",
    selected: "已選擇{orderQty}件商品"
  },
  global: {
    spec: "規格",
    orderConfirm: "請確認您要下單的商品",
    total: "合計",
    instant: "立即下單",
    model: "型號",
    noData: "暫無數據"

  },
  placeorder: {
    success: "下單成功！請您查看訂單詳情並支付！",
    lack: "妳訂單中的部分物品缺貨，正在為您下單其他物品...",
    lackall: "您訂單中的所有商品都缺貨！無法下單！",
    globalamount: "該活動已經到達金額上限,無法繼續下單!",
    perskuqty: "部分商品已經到達購買數量上限!",
    globalqty: "已經到達全部商品購買數量上限",
    typeqty: "部分類別商品已經到達購買數量上限!",
    catqty: "部分類別商品已經到達購買數量上限!",
    retry: "出錯了，請重試！",
    orderqty: "您已經到達訂單數量上限!",
    pointlack: "您沒有足夠的積分!",
    over: "活動已經結束!",
    personalamount: "您已經到達金額限制!"
  },
  cartMsg: {
    // lackall: "商品缺貨！無法下單！",
    // globalamount: "該活動已經到達金額上限,無法繼續下單!",
    // perskuqty: "該商品已經到達購買數量上限!",
    // globalqty: "已經到達全部商品購買數量上限",
    // typeqty: "該商品已經到達類別購買數量上限!",
    // catqty: "該商品已經到達類別購買數量上限!",
    success: "商品已經成功添加到購物車",
    lackall: "商品缺貨！無法下單！",
    globalamount: "該活動已經到達金額上限,無法繼續下單!",
    perskuqty: "限購產品，不可以太貪心哦！",
    globalqty: "已經到達全部商品購買數量上限",
    typeqty: "該類別商品已經到達購買數量上限!",
    catqty: "該類別商品已經到達購買數量上限!",
    orderqty: "您已經到達訂單數量上限!",
    pointlack: "您沒有足夠的積分!",
    over: "活動已經結束!",
    personalamount: "您已經到達金額限制!",
    0: "商品已經成功添加到購物車",
    2: "商品缺貨！無法下單！",
    3: "商品缺貨！無法下單！",
    4: "該活動已經到達金額上限,無法繼續下單!",
    5: "限購產品，不可以太貪心哦！",
    6: "已經到達全部商品購買數量上限",
    7: "該類別商品已經到達購買數量上限!",
    8: "該類別商品已經到達購買數量上限!",
    9: "您已經到達訂單數量上限!",
    10: "您沒有足夠的積分!",
    11: "您已經到達金額限制!",
    12: "您沒有足夠的剩余額度!",
    retry: "出錯了，請重試！"
  },
  session: {
    end: "已經結束!",
    start: "將於 {date} 開始!",
    text: "倒計時",
    countdown: "{days} 天 {hours} 時 {minutes} 分 {seconds} 秒"
  },
  search: {
    info: "搜索您感興趣的商品",
    notfound: "抱歉，沒有找到與“{searchKeyWord}”相關的商品",
    placeholder: "搜索",
    history:"搜索歷史"
  }
}




// WEBPACK FOOTER //
// ./src/locales/zh.js